import React, { useEffect, useState } from 'react';
import { TimerIcon } from 'lucide-react';
const TOTAL_SECONDS = 22 * 60 + 22;
function useCountdown(initialSeconds: number) {
  const [seconds, setSeconds] = useState(initialSeconds);
  useEffect(() => {
    const id = setInterval(() => setSeconds(s => s > 0 ? s - 1 : 0), 1000);
    return () => clearInterval(id);
  }, []);
  return {
    mm: Math.floor(seconds / 60),
    ss: seconds % 60
  };
}
function Unit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <span className="inline-flex items-baseline gap-1" data-id="element-146" data-mp="k294no01quwl">
      <span className="font-display text-2xl font-extrabold tabular-nums leading-none" style={{
      color: "#FFB547"
    }} data-id="element-147" data-mp="k429cxr3n51y">
        {String(value).padStart(2, '0')}
      </span>
      <span className="text-[10px] font-semibold uppercase tracking-wider text-white/55" style={{
      color: "#FFB547"
    }} data-id="element-148" data-mp="acpk8dwoqszm">{label}</span>
    </span>;
}
export function OfferBar() {
  const {
    mm,
    ss
  } = useCountdown(TOTAL_SECONDS);
  return <div role="region" aria-label="Conto alla rovescia dell'offerta" className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-obsidian text-white" data-id="element-149" data-mp="qzbo4cvslr6q">
      <div className="mx-auto flex h-11 max-w-6xl items-center justify-center gap-3 px-4 sm:gap-5" data-id="element-150" data-mp="mzt21ds8ja2b">
        <p className="flex items-center gap-1.5 whitespace-nowrap text-[11px] font-bold uppercase tracking-[0.16em] text-ember sm:text-xs" data-id="element-151" data-mp="10vey24wvyu48">
          <TimerIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-152" data-mp="88anlkf0xnl2" />
          L’offerta scade tra:
        </p>
        <p className="flex items-baseline gap-1.5" aria-live="off" data-id="element-153" data-mp="3asglzkkhifp">
          <Unit value={mm} label="Min" data-id="element-154" data-mp="hydijq5phbm1" />
          <span className="font-display text-xl font-bold text-white/40" data-id="element-155" data-mp="hzf4ipo9fiij">:</span>
          <Unit value={ss} label="Sec" data-id="element-156" data-mp="d7na241zgsn4" />
        </p>
      </div>
    </div>;
}